import React from "react";
import { Link } from "react-router-dom";
import { Reveal } from "@/components/effects/Reveal";
import { FEATURED_EVENTS } from "@/lib/data";
import { ArrowUpRight } from "lucide-react";

export const FeaturedEvents = ({ limit = 5, title = "Featured Events" }) => {
  const events = FEATURED_EVENTS.slice(0, limit);
  return (
    <section data-testid="featured-events" className="relative py-28 sm:py-36">
      <div className="max-w-[1280px] mx-auto px-6 sm:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-14">
          <div>
            <Reveal>
              <p className="text-[11px] tracking-luxe uppercase text-white/45 mb-4">— {title}</p>
            </Reveal>
            <Reveal delay={120}>
              <h2 className="font-display text-4xl sm:text-5xl md:text-6xl leading-[1.05]">
                <span className="text-chrome">Selected</span>{" "}
                <span className="italic text-magcyan">stories</span>{" "}
                <span className="text-chrome">from the field.</span>
              </h2>
            </Reveal>
          </div>
          <Reveal delay={220}>
            <Link to="/events" data-testid="featured-events-view-all" className="btn-ghost">View All Events</Link>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {events.map((e, i) => (
            <Reveal key={e.id} delay={i * 90}>
              <article
                data-testid={`featured-event-${i}`}
                className={`group relative photo-frame chrome-border h-full overflow-hidden ${
                  i === 0 ? "lg:row-span-2 lg:col-span-2 aspect-[16/11]" : "aspect-[4/5]"
                }`}
              >
                <img
                  src={e.image}
                  alt={e.title}
                  className="absolute inset-0 w-full h-full object-cover"
                  loading="lazy"
                />
                <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, transparent 40%, rgba(0,0,0,0.92))" }} />
                <div className="absolute top-4 left-4">
                  <span className="text-[10px] tracking-luxe uppercase px-2.5 py-1 rounded-full glass-strong border border-white/15 text-white/85">
                    {e.category}
                  </span>
                </div>
                <div className="absolute inset-x-0 bottom-0 p-5 sm:p-7 max-w-full">
                  <p className="text-[10px] tracking-luxe uppercase text-white/55 mb-2">{e.date}</p>
                  <h3 className={`font-display ${i === 0 ? "text-2xl sm:text-3xl md:text-4xl" : "text-xl sm:text-2xl"} text-chrome leading-[1.15] break-words`}>
                    {e.title}
                  </h3>
                  <p className="mt-3 text-sm text-white/65 font-body line-clamp-2 max-w-[34ch]">{e.desc}</p>
                  <div className="mt-4 inline-flex items-center gap-2 text-[11px] tracking-luxe uppercase text-white/80 group-hover:text-white">
                    View Event
                    <ArrowUpRight className="w-3.5 h-3.5" />
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedEvents;
